export enum ButtonColorsEnum {
  Primary = 'primary',
  Accent = 'accent',
  Warn = 'warn'
}
